export const WIDGET_TYPES = {
  EMBED: 'Embed Widget',
  DIVIDER: 'Divider Widget',
  WYSIWYG_TEXT: 'WYSIWYG Text Widget',
  IMAGE_GALLERY: 'Image Gallery',
  FULL_SIZE_IMAGE_ONLY_BANNER: 'Full-size Image only banner',
  CONTENT_SELECTION: 'Content Selection',
  UNCATEGORIZED_CUSTOMER_GROUP_CONTENT: 'Uncategorized Customer Group Content',
  IMAGE_BANNER: 'Image Banner',
  COLLECTION: 'Collection Widget',
  PODCAST: 'Podcast Widget',
  EVISCO_LIVESTREAM: 'Evisco Livestream',
} as const;

export const WIDGET_TEMPLATES = {
  BASIC: 'Basic Template',
  HERO: 'Hero List',
  CAROUSEL: 'Carousel List',
  CARD_LIST: 'Card List',
  SPOTLIGHT: 'Spotlight',
  MEDIA_RAIL: 'Media Rail',
} as const;
